import { useTranslation } from "react-i18next";

const Logo = () => {
  const { t } = useTranslation("landing");

  return (
    <a
      href="/"
      aria-label="Rayabot"
      className="flex shrink-0 items-center gap-2.5 text-[20px] font-black tracking-tight sm:gap-3 sm:text-[22px]"
    >
      <div className="relative grid h-10 w-10 shrink-0 place-items-center overflow-hidden rounded-[14px] bg-gradient-to-br from-teal to-teal-2 text-[18px] font-black text-white shadow-[0_10px_24px_rgba(15,118,110,0.4)] sm:h-11 sm:w-11">
        <img src="/logo_raya_otp.png" alt="R"/>
      </div>

      <span className="flex items-baseline text-ink">
        <span>{t("brand.part1")}</span>
        <span className="bg-gradient-to-br from-gold to-gold-2 bg-clip-text text-transparent">
          {t("brand.part2")}
        </span>
      </span>
    </a>
  );
};

export default Logo;